export default "__VITE_ASSET__DTea6j6y__"